import styled from '@emotion/styled';

import { SCREEN_SIZE } from '@shared/v2/constants';

import GlobalCVPBanner from '@/components/GlobalCVPBanner';

// NOTE: Our current CVPBanner (component that's wrapped by GlobalCVPBanner) has
// a lot baked in styling that's not easily modifiable, without this monstrosity.
const CVPBanner = styled(GlobalCVPBanner)`
  // Mobile and up
  margin-top: 0;
  padding-top: 0;
  padding-bottom: 0;

  > div {
    padding-top: 0;
    padding-bottom: 0;

    > div {
      padding-bottom: 16px;
    }
  }

  // Desktop
  ${SCREEN_SIZE.LG} {
    margin-top: 32px;

    > div {
      padding-top: 0;

      > div {
        background-color: #f6f6f6;
        padding-bottom: 0;
      }
    }
  }
`;

export default CVPBanner;
